
/* injects from baggage-loader */

import Config from "../../../config/main";
import Helpers from "../../helperFunctions";
export const getBoostedOdds = (gameId, gameType) => {
    let boosted = [];
    if (!gameId) return {}

    let boostedGameIdsNumberConverted = Object.keys(gameId);
    for (let i = 0; i <= boostedGameIdsNumberConverted.length; i++) {
        if (i < 50) {
            boosted.push(Number(boostedGameIdsNumberConverted[i]));
        }
    }
    let mergedMarkets = Helpers.asianViewMarketMerge(Config.sportListThatCanBeBoostedOdds, Config.asianViewMarket, gameType);

    let outright = { "display_key": "OUTRIGHT" };
    mergedMarkets.push(outright);

    let req = {
        "source": "betting",
        "what": {
            "sport": ["id", "name", "alias", "order"],
            "competition": ["id", "name"],
            "region": ["id", "name", "alias"],
            "game": ["id", "start_ts", "show_type", "team1_name", "team2_name", "team1_external_id", "team2_external_id", "type", "info", "markets_count", "extra", "is_blocked", "exclude_ids", "is_stat_available", "game_number", "game_external_id", "is_live", "is_neutral_venue", "game_info", "sportcast_id"],
            "event": ["name", "id", "base", "type", "type_1", "price", "show_type"],
            "market": ["base", "id", "name", "order", "sequence", "show_type", "cashout", "display_key", "display_sub_key", "market_type", "home_score", "away_score", "main_order", "optimal", "col_count", "group_id", "express_id", "group_name"]
        },
        "where": {
            "game": { "id": { "@in": boosted }, "type": { "@in": gameType === "prematch" ? [0, 2] : [1] } },
            "market": { "@or": mergedMarkets }
        }
    };
    return req;
};